<template>
  <div class="mb-10">
    <page-title value="認定情報設定"></page-title>

    <v-card variant="flat" class="mt-6 pa-2" color="grey-lighten-5">
      <v-container>
        <v-row>
          <v-col cols="3">
            <h5>クラス</h5>
            <class-picker
              :classes="classes"
              v-model="searchFilter.classId"
            ></class-picker>
          </v-col>

          <v-col cols="3">
            <h5>年齢</h5>
            <age-picker v-model="searchFilter.age"></age-picker>
          </v-col>

          <v-col cols="3">
            <h5>性別</h5>
            <v-select
              v-model="searchFilter.gender"
              :items="genderItems"
              variant="outlined"
              density="compact"
            ></v-select>
          </v-col>

          <v-col cols="3" align-self="center">
            <v-checkbox
              v-model="searchFilter.isQuit"
              color="primary"
              label="退園済み"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row justify="center" no-gutters>
          <v-col cols="2">
            <v-btn
              @click="searchFee"
              color="primary"
              variant="flat"
              block
              :loading="isLoading"
              >検索</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <div class="mt-8">
      <v-expansion-panels>
        <v-expansion-panel v-for="(item, i) in feeList" :key="i">
          <v-expansion-panel-title>
            <template v-slot:default>
              <v-row>
                <v-col cols="auto">
                  {{ item.child.lastName + item.child.firstName }}
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>保育区分</th>
                    <th>階層</th>
                    <th>保育必要量</th>
                    <th>保育料</th>
                    <th>-</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(feeItem, i) in item.fees" :key="i">
                    <td>
                      {{
                        certifiedCategoryItems.find(
                          (v) => v.value == feeItem.certifiedCategory
                        )?.title
                      }}
                    </td>
                    <td>{{ feeItem.rank }}</td>
                    <td>
                      {{
                        childcareCategoryItems.find(
                          (v) => v.value == feeItem.childcareCategory
                        )?.title
                      }}
                    </td>
                    <td>{{ feeItem.fee + "円" }}</td>
                    <td>
                      <v-btn
                        @click="
                          selectChild({ child: item.child, fee: feeItem })
                        "
                        :disabled="isLoading"
                        color="primary"
                        variant="outlined"
                        small
                        >編集</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-table>
            <div class="pa-4">
              <v-btn
                @click="selectChild({ child: item.child })"
                :disabled="isLoading"
                color="primary"
                small
                variant="outlined"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <!-- dialog -->
    <v-form v-model="isDialogFormValid">
      <v-dialog v-model="editDialog" max-width="620px" persistent>
        <v-card>
          <v-card-title>認定情報設定</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <h5>認定番号</h5>
                  <v-text-field
                    v-model="input.certificationNumber"
                    :disabled="isUpdate"
                    variant="outlined"
                    hide-details
                    density="compact"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <h5>認定期間 開始日時*</h5>
                  <v-text-field
                    v-model="input.periodStart"
                    :rules="[required]"
                    clearable
                    variant="outlined"
                    hide-details
                    density="compact"
                    type="date"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <h5>認定期間 終了日時</h5>
                  <v-text-field
                    v-model="input.periodEnd"
                    variant="outlined"
                    clearable
                    hide-details
                    density="compact"
                    type="date"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h5>階層</h5>
                  <v-text-field
                    v-model="input.rank"
                    :disabled="isUpdate"
                    variant="outlined"
                    hide-details
                    density="compact"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h5>副食費全額減免</h5>
                  <v-checkbox
                    v-model="input.isFoodCostExempted"
                    :disabled="isUpdate"
                    label="全額減免"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h5>保育認定*</h5>
                  <v-select
                    v-model="input.certifiedCategory"
                    :disabled="isUpdate"
                    :rules="[required]"
                    :items="certifiedCategoryItems"
                    variant="outlined"
                    hide-details
                    density="compact"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h5>保育必要量*</h5>
                  <v-select
                    v-model="input.childcareCategory"
                    :disabled="isUpdate"
                    :rules="[required]"
                    :items="childcareCategoryItems"
                    variant="outlined"
                    hide-details
                    density="compact"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h5>保育料（基本料金）*</h5>
                  <v-text-field
                    v-model="input.fee"
                    :disabled="isUpdate"
                    :rules="[required]"
                    variant="outlined"
                    hide-details
                    density="compact"
                    suffix="円"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-btn @click="editDialog = false" color="grey" text
                  >キャンセル</v-btn
                >
                <v-spacer />
                <v-btn
                  @click="clickSave"
                  :disabled="isLoading || !isDialogFormValid"
                  color="primary"
                  variant="flat"
                >
                  <div v-if="isUpdate">保存</div>
                  <div v-else>作成</div>
                </v-btn>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import {
  ChildResponse,
  NurseryClassResponse,
  NurseryFeeResponse,
} from "chaild-api/lib";
import { feeModule } from "@/store/dataModules/feeModule";
import LocalDataService from "@/service/LocalDataService";
import AgePicker from "@/components/atoms/AgePicker.vue";
import ClassPicker from "@/components/atoms/ClassPicker.vue";
import { classModule } from "@/store/dataModules/classModule";
import Swal from "sweetalert2";
import ValidationMixin from "@/mixins/ValidationMixin";
import {
  invoiceModule,
  InvoiceStatus,
} from "@/store/dataModules/invoiceModule";
import dayjs from "dayjs";

export default defineComponent({
  name: "FeeSetting",

  mixins: [ValidationMixin],

  components: {
    PageTitle,
    ClassPicker,
    AgePicker,
  },

  watch: {
    editDialog(value) {
      if (!value) {
        this.clearInput();
      }
    },
  },

  data() {
    return {
      isLoading: false,
      editDialog: false,
      searchFilter: {
        gender: "" as "" | "male" | "female",
        age: null as null | number,
        classId: null as null | number,
        isQuit: false,
      },
      genderItems: [
        { title: "すべて", value: "" },
        { title: "男性", value: "male" },
        { title: "女性", value: "female" },
      ],
      certifiedCategoryItems: [
        { title: "1号", value: "one" },
        { title: "2号", value: "two" },
        { title: "3号", value: "three" },
      ],
      childcareCategoryItems: [
        { title: "標準時間保育", value: "normal" },
        { title: "短時間保育", value: "short" },
      ],
      beforePeriodStart: "",
      input: {
        childId: "",
        nurseryFeeId: "",
        certificationNumber: "",
        periodStart: "",
        periodEnd: "" as string | null,
        rank: "",
        certifiedCategory: "one",
        childcareCategory: "normal",
        fee: "",
        isFoodCostExempted: false,
        prefecture: "",
        city: "",
        localCode: "",
      },
      isDialogFormValid: false,
    };
  },

  async mounted() {
    await this.searchFee();
    await this.listClass();
  },

  computed: {
    feeList: function (): NurseryFeeResponse[] {
      if (this.searchFilter.isQuit) {
        // return feeModule.feeList.filter((f) => f.child.quitDate != null);
        return feeModule.feeList.filter((f) =>
          dayjs().isAfter(f.child.quitDate)
        );
      } else {
        return feeModule.feeList.filter(
          (f) => f.child.quitDate == null || !dayjs().isAfter(f.child.quitDate)
        );
      }
    },
    classes: function (): NurseryClassResponse[] {
      return classModule.classes;
    },
    isUpdate: function (): boolean {
      return this.input.nurseryFeeId !== "";
    },
  },

  methods: {
    async searchFee() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await feeModule.searchFee({
          nurseryId: nurseryId,
          age: this.searchFilter.age !== null && this.searchFilter.age !== undefined ? String(this.searchFilter.age) : undefined,
          gender: this.searchFilter.age !== null && this.searchFilter.age !== undefined ? this.searchFilter.gender : undefined,
          classId: this.searchFilter.classId
            ? String(this.searchFilter.classId)
            : undefined,
          limit: 1000,
          skip: 0,
        });
      }
      this.isLoading = false;
    },
    async listClass() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule.listClass({
          nurseryId,
        });
      }
    },
    async clickSave() {
      if (this.isUpdate) {
        await this.updateFee();
      } else {
        await this.createFee();
      }
    },
    async createFee() {
      this.isLoading = true;
      const response = await feeModule
        .createFee({ ...this.input })
        .catch(() => {
          alert(
            "認定・保育料の期間指定が不正です。他の期間との重複がないか確認してください。"
          );
          this.editDialog = false;
        });
      if (response) {
        Swal.fire({ title: "保存しました" });
        this.editDialog = false;
        await this.searchFee();
      }
      this.isLoading = false;
    },
    async updateFee() {
      this.isLoading = true;
      const response = await feeModule
        .updateFee({
           ...this.input,
           beforePeriodStart: this.beforePeriodStart,
         })
        .catch(() => {
          alert(
            "この月の売上情報が確定しているため、 対象期間を含む保育料・認定情報は編集できません。"
          );
          this.editDialog = false;
        });
      if (response) {
        Swal.fire({ title: "保存しました" });
        this.editDialog = false;
        await this.searchFee();
      }
      this.isLoading = false;
    },
    // selectChild(feeId?: number) {
    selectChild(input: { child: ChildResponse; fee?: NurseryFeeResponse }) {
      if (input.child) {
        // const _fee = this.feeList.find(f => f.nurseryFeeId == feeId);
        this.input.childId = String(input.child.childId);
        if (input.fee) {
          this.input = {
            childId: String(input.child.childId),
            nurseryFeeId: String(input.fee.nurseryFeeId),
            certificationNumber: input.fee.certificationNumber || "",
            periodStart: input.fee.periodStart,
            periodEnd: input.fee.periodEnd || "",
            rank: input.fee.rank || "",
            certifiedCategory: input.fee.certifiedCategory,
            childcareCategory: input.fee.childcareCategory || "normal",
            fee: String(input.fee.fee) || "",
            isFoodCostExempted: input.fee.isFoodCostExempted,
            prefecture: input.fee.prefecture || "",
            city: input.fee.city || "",
            localCode: input.fee.localCode || "",
          };
          this.beforePeriodStart = this.input.periodStart;
        }
      }
      this.editDialog = true;
    },
    clearInput() {
      this.input = {
        childId: "",
        nurseryFeeId: "",
        certificationNumber: "",
        periodStart: "",
        periodEnd: "" as string | null,
        rank: "",
        certifiedCategory: "one",
        childcareCategory: "normal",
        fee: "",
        isFoodCostExempted: false,
        prefecture: "",
        city: "",
        localCode: "",
      };
    },
  },
});
</script>
